<template>
    <div class="fixed-modal-doc-viewer fixed-modal-doc-viewer-office" >
        <div class="position-absolute close-icon-for-viewer close-icon-for-viewer-office">
          <h1 class="fs-16 text-secondary pt-5 pl-5">{{file_name_for_view}}</h1>
          <span class="position-absolute pointer" style="right: 15px; top: 15px;">
            <i class="icon icon-close fs-18 text-black" @click="hideFileViewer" style="left: 3px;" ></i>
          </span>
        </div>
        <!-- <div class="position-absolute close-icon-for-viewer-other" v-else>
          <h1 class="fs-16 text-secondary pt-3 pl-5">{{file_name_for_view}}</h1>
          <span class="position-absolute pointer" style="right: 15px; top: 10px;">
            <i class="icon icon-close fs-18 text-black" @click="hideFileViewer" style="left: 3px;" ></i>
          </span>
        </div> -->
        <div v-if="show_print_screen_page_disable_error" class="show-print-screen-dummy-page d-flex align-items-center justify-content-center">
          <h1 class="fs-16 text-center">Screenshots are not allowed.</h1>
        </div>
        <!-- <div class="preview-page-white-overlay"></div> -->
        <div v-if="/\.(docx|pptx|doc|ppt)$/i.test(file_name_for_view)" class="hide-utility-icons-for-doc-ppt" :class="{'hide-utility-icons-for-ppt':/\.(pptx|ppt)$/i.test(file_name_for_view)}">
  
        </div>
        <div v-if="/\.(pdf|svg|txt)$/i.test(file_name_for_view)" class="hide-utility-icons-for-pd-svg-txt">
  
        </div>
        <template v-if="fileUrl == '' || fileUrl == null || fileUrl == undefined">
          <div class="w-100 h-100 d-flex align-items-center justify-content-center bg-white">
            <h1 class="fs-16 py-5 text-center"> File Type Not Supported</h1>
          </div>
        </template>
        <div class="w-100 h-100 bg-white" v-else>
          <!-- <div class="w-100 h-100 d-flex align-items-center justify-content-center bg-white position-absolute" style="z-index: 0;">
            <h1 class="fs-16 py-5 text-center"> File Not Loaded, Please Try Again.</h1>
          </div> -->
          <div v-if="/\.(docx|xlsx|pptx|doc|xls|ppt)$/i.test(file_name_for_view)" class="w-100 h-100 position-relative" style="z-index: 1;">
            <!-- <iframe id="wacParentframenew" ref="officeViewer" :src="'https://view.officeapps.live.com/op/view.aspx?src=https://cdn.digicollect.com/cdn/hrms_fe_v2/test.doc#toolbar=0'" frameborder="0" width="100%" height="100%" ></iframe> -->
            <iframe id="wacParentframe" ref="myIframe" :src="'https://view.officeapps.live.com/op/embed.aspx?src='+fileUrl" frameborder="0" width="100%" height="100%" ></iframe>
          </div>
          <!-- <div v-else-if="file_type_for_view == 'application/pdf'" class="w-100 h-100"> -->
          <div v-else-if="/\.(pdf|svg|txt|html)$/i.test(file_name_for_view)" class="w-100 h-100 position-relative" style="z-index: 1;">
              <iframe :src="'https://docs.google.com/viewer?url='+fileUrl+'&embedded=true'" frameborder="0" width="100%" height="100%" ></iframe>
              <!-- <div class="w-100 h-100" id="PdfViewerNew">
  
              </div> -->
          </div>
          <div v-else class="w-100 h-100 d-flex align-items-center justify-content-center bg-white">
            <h1 class="fs-16 py-5 text-center"> File Type Not Supported</h1>
          </div>
        </div>
    </div>
  </template>
  <script>
  import Axios from 'axios';
  import {HollowDotsSpinner} from 'epic-spinners';
  // import PDFJSExpress from '@pdftron/pdfjs-express-viewer'
  export default {
    props: ["fileUrl","fileType","file_name_for_view","file_type_for_view"],
    data() {
      return {
        pdfUrl: '',
        previewType: '',
        isLoading: true,
        page: 1,
        pageCount: 1,
        showAllPages: false,
        show_print_screen_page_disable_error: false
      };
    },
    components: {
      HollowDotsSpinner,
    },
    watch: {
        showAllPages() {
            this.page = this.showAllPages ? null : 1
        },
    },
    created() {
    },
    mounted() {
      //   PDFJSExpress(
      //   {
      //     path: '/static/pdfjsexpress',
      //     // path: 'https://storage.googleapis.com/',
      //     // initialDoc: '/static/f866c5a9-1568-4f63-b1d8-6353d10f24de.pdf',
      //     licenseKey: 'xDcYT6Z1D7Rmf4R5N0Zq',
      //   },
      //   document.getElementById('PdfViewerNew')
      // ).then(instance => {
      //   const { UI, Core } = instance;
      //   const { documentViewer, annotationManager, Tools, Annotations } = Core;
      //   // call methods from UI, Core, documentViewer and annotationManager as needed
  
      //   documentViewer.addEventListener('documentLoaded', () => {
      //     // call methods relating to the loaded document
      //   });
  
      //   instance.UI.loadDocument(this.fileUrl);
      // })
      // Add event listener for keydown
      // document.addEventListener('keyup', this.handleKeyDown);
    },
    beforeDestroy() {
      // Remove event listener when component is destroyed
      // document.removeEventListener('keyup', this.handleKeyDown);
    },
    computed: {
  
    },
    methods: {
      hideFileViewer(){
        this.$emit('hideFileViewer')
      },
      handleIFrameLoad() {
        // const iframe = this.$refs.myIframe;
        const iframe = document.getElementById('wacParentframe');
        iframe.contentWindow.postMessage('requestCSSChange', '*');
        this.injectIframeStyle()
      },
      changeIFrameCSS() {
        // Handle CSS change on receiving message from iframe
      },
      handleDocumentRender() {
          this.isLoading = false
          this.pageCount = this.$refs.pdfRef.pageCount
      },
      handlePasswordRequest(callback, retry) {
          callback(prompt(retry
              ? 'Enter password again'
              : 'Enter password'
          ))
      },
      injectIframeStyle() {
        const iframe = document.getElementById('wacParentframe');
        const cssString = `
          body {
            background-color: lightblue;
          }
        `;
        let iframeContent = iframe.contentWindow
        // iframe.contentWindow.frames.contentWindow.postMessage({ css: cssString }, '*'); // Replace '*' with the target iframe's origin if known
        // iframe.contentWindow.frames.postMessage({ css: cssString }, '*')
        if (iframeContent) {
          const body = iframeContent.body;
          if (body) {
            body.style.backgroundColor = 'lightblue';
          }
        }
      },
      handleKeyDown(event) {
        // Check if the pressed key is the print screen key
        if (event.key === 'PrintScreen' || event.key === 'PrtScn' || event.keyCode === 44) {
          // Prevent the default behavior (taking a screenshot)
          event.preventDefault();
          // Optionally, you can also stop the event from propagating further
          event.stopPropagation();
          // Optionally, you can show a message or perform some other action
          this.show_print_screen_page_disable_error = true;
        }
        if (event.metaKey && event.shiftKey && (event.keyCode === 83 || event.keyCode === 51 || event.keyCode === 53)) {
          // Prevent the default behavior (taking a screenshot)
          event.preventDefault();
          // Optionally, you can also stop the event from propagating further
          event.stopPropagation();
          // Optionally, you can show a message or perform some other action
          this.show_print_screen_page_disable_error = true;
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .fixed-modal-doc-viewer {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 99999999;
  }
  .testing-viewer {
    height: 100% !important;
  }
  .testing-viewer #AppHeaderPanel {
    display: none !important;
  }
  .cui-exth .WACRibbonPanel {
    display: none !important;
  }
  
  .cui-ribbonTopBars, .cui-tabBody, .cui-cg-i, .cui-ct-ul, .cui-tabContainer {
    display: none !important;
  }
  .ndfHFb-c4YZDc-Wrql6b {
    display: none !important;
  }
  button[aria-label="Accessibility Mode"] {
  display: none !important;
   }
   .close-icon-for-viewer {
      right: 0;
      top: 0;
      z-index: 99999999;
      background-color: #fff;
      width: 100%;
      height: 60px;
   }
   .close-icon-for-viewer-other {
      right: 0;
      top: 0;
      z-index: 99999999;
      background-color: #fff;
      width: 100%;
      height: 50px;
   }
   .controls {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 1rem;
    }
    button {
      margin: 0 0.5rem;
    }
    .fixed-modal-doc-viewer-office {
      top: 60px;
      height: auto;
    }
    .close-icon-for-viewer-office {
      top: -60px;
      height: 60px;
    }
    .hide-utility-icons-for-doc-ppt {
      position: absolute;
      bottom: 1px;
      right: 40px;
      width: 47px;
      height: 20px;
      background-color: #fff;
      z-index: 99999;
    }
    .hide-utility-icons-for-ppt {
      background-color: #444444;
      bottom: 1px;
      right: 45px;
      width: 45px;
      height: 23px;
    }
    .hide-utility-icons-for-pd-svg-txt {
      position: absolute;
      top: 12px;
      right: 12px;
      width: 40px;
      height: 40px;
      background-color: #fff;
      z-index: 99999;
    }
    .show-print-screen-dummy-page {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 999999;
      background-color: #fff;
    }
    .preview-page-white-overlay {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 999999;
      background-color: rgba(255, 255, 255, 0.1);
    }
  </style>
  


// WEBPACK FOOTER //
// src/components/FilesViewerCallReport.vue